<template>
  <a-card class="style1">
    <a-tabs default-active-key="1">
      <a-tab-pane key="1" tab="All Users">
        <a-button type="primary" class="mb-3" @click="createUser">Create user</a-button>
        <a-table :loading="isLoading" :columns="columns" :data-source="userData" :pagination="pagination1" @change="handleTable1Change" size="middle" bordered rowKey="id">
          <div slot="role" slot-scope="text">{{ getRoleInfo(text) }}</div>
          <div slot="cards" slot-scope="text, record" class="d-flex justify-content-between">
            <span>
              {{ getRemainingCards(record) }}
            </span>
            <a-button type="link" size="small" icon="edit" :disabled="!record.membership" @click="e => editRemainingCards(record)"></a-button>
          </div>
          <div slot="restricted" slot-scope="text, record">
            <!-- {{ text ? 'restricted' : 'unrestricted' }} -->

            <a-radio-group :default-value="text || record.state !== 'active' || false" @change="e => onChangeUserRestrict(e, record)" button-style="solid">
              <a-radio-button :value="true"> Restricted </a-radio-button>
              <a-radio-button :value="false"> Unrestricted </a-radio-button>
            </a-radio-group>
          </div>
          <div slot="show_notice" slot-scope="text, record">
            <a-radio-group :value="record.show_notice === true" @change="e => onChangeUserShowNotice(e, record)" button-style="solid">
              <a-radio-button :value="true"> show </a-radio-button>
              <a-radio-button :value="false"> hide </a-radio-button>
            </a-radio-group>
          </div>
          <div slot="signature" slot-scope="record" class="signature">
            <img v-if="record != ''" :src="record" @click="onDownloadSignature(record)" style="cursor: pointer" />
            <a v-else href="javascript:;"></a>
          </div>
          <div slot="action" slot-scope="record" class="action">
            <a href="javascript:;" @click="onEdit(record)">Edit</a>
            <a-popconfirm title="Are you sure？" ok-text="Yes" cancel-text="No" @confirm="onDelete(record)">
              <a href="javascript:;">Delete</a>
            </a-popconfirm>
          </div>
          <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }" style="padding: 8px">
            <a-input
              v-ant-ref="c => (searchInput = c)"
              :placeholder="`Search ${column.title}`"
              :value="selectedKeys[0]"
              style="width: 190px; margin-bottom: 8px; display: block"
              @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
              @pressEnter="() => handleSearch(selectedKeys, confirm, column.key)"
            />
            <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px" @click="() => handleSearch(selectedKeys, confirm, column.key)">Search</a-button>
            <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">Reset</a-button>
          </div>
          <a-icon slot="filterIcon" slot-scope="filtered" type="search" :style="{ color: filtered ? '#108ee9' : undefined }" />
        </a-table>
      </a-tab-pane>
      <a-tab-pane key="2" tab="Users without Jesus Story">
        <div style="display: flex; justify-content: flex-end">
          <a :href="apiURL + '/api/v1/list_users_without_story.csv'" style="background-color: #007bff; color: white; border-radius: 5px; padding: 5px 15px; cursor: pointer; margin-bottom: 15px">
            Download CSV
          </a>
        </div>
        <a-table :loading="isLoading" :columns="columns2" :data-source="userListWithoutStory" :pagination="pagination2" @change="handleTable2Change" size="middle" bordered rowKey="id">
          <div slot="role" slot-scope="text">{{ getRoleInfo(text) }}</div>
          <a-icon slot="filterIcon" slot-scope="filtered" type="search" :style="{ color: filtered ? '#108ee9' : undefined }" />
        </a-table>
      </a-tab-pane>
      <a-tab-pane key="3" tab="Users without Order Cards">
        <div style="display: flex; justify-content: flex-end">
          <a :href="apiURL + '/api/v1/list_users_without_order_cards.csv'" style="background-color: #007bff; color: white; border-radius: 5px; padding: 5px 15px; cursor: pointer; margin-bottom: 15px">
            Download CSV
          </a>
        </div>
        <a-table :loading="isLoading" :columns="columns2" :data-source="userListWithoutOrderCards" :pagination="pagination3" @change="handleTable3Change" size="middle" bordered rowKey="id">
          <div slot="role" slot-scope="text">{{ getRoleInfo(text) }}</div>
          <a-icon slot="filterIcon" slot-scope="filtered" type="search" :style="{ color: filtered ? '#108ee9' : undefined }" />
        </a-table>
      </a-tab-pane>
      <a-tab-pane key="4" tab="Users without Church Connection">
        <div style="display: flex; justify-content: flex-end">
          <a
            :href="apiURL + '/api/v1/list_users_without_church_connection.csv'"
            style="background-color: #007bff; color: white; border-radius: 5px; padding: 5px 15px; cursor: pointer; margin-bottom: 15px"
          >
            Download CSV
          </a>
        </div>
        <a-table :loading="isLoading" :columns="columns2" :data-source="userListWithoutChurchConnection" :pagination="pagination4" @change="handleTable4Change" size="middle" bordered rowKey="id">
          <div slot="role" slot-scope="text">{{ getRoleInfo(text) }}</div>
          <a-icon slot="filterIcon" slot-scope="filtered" type="search" :style="{ color: filtered ? '#108ee9' : undefined }" />
        </a-table>
      </a-tab-pane>
    </a-tabs>
    <a-modal v-model="isVisibleModal" :title="isEdit ? 'Update user information' : 'Create user'" centered @ok="handleSubmit" :destroyOnClose="true" :closable="true" :maskClosable="false">
      <template slot="footer">
        <a-button key="back" :loading="isLoading" @click="handleCancel">Return</a-button>
        <a-button key="submit" type="primary" :loading="isLoading" @click="handleSubmit">Submit</a-button>
      </template>
      <a-form class="mb-4" :form="form" @submit="handleSubmit">
        <a-form-item>
          <a-input size="large" placeholder="First name" v-decorator="['firstname', { rules: [{ required: true, message: 'Please input first name!' }] }]" />
        </a-form-item>
        <a-form-item>
          <a-input size="large" placeholder="Last name" v-decorator="['lastname', { rules: [{ required: true, message: 'Please input last name!' }] }]" />
        </a-form-item>
        <a-form-item>
          <a-input
            size="large"
            placeholder="Email"
            type="email"
            v-decorator="[
              'email',
              {
                rules: [
                  { type: 'email', message: 'The input is not valid E-mail!' },
                  { required: true, message: 'Please input email!' },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item>
          <a-checkbox-group v-decorator="['role']" :options="roleInfo" />
        </a-form-item>
        <a-form-item>
          <a-input
            size="large"
            placeholder="Password"
            @change="isChangedPassword"
            v-decorator="[
              'password',
              {
                rules: [
                  {
                    validator: validateToNextPassword,
                  },
                ],
              },
            ]"
            type="password"
          />
        </a-form-item>
        <a-form-item>
          <a-input
            size="large"
            placeholder="Confirm Password"
            v-decorator="[
              'confirm',
              {
                rules: [
                  {
                    required: isChangedPass,
                    message: 'Please confirm your password!',
                  },
                  {
                    validator: compareToFirstPassword,
                  },
                ],
              },
            ]"
            type="password"
            @blur="handleConfirmBlur"
          />
        </a-form-item>
        <!-- <a-form-item>
          <a-input size="large" placeholder="Phone number" v-decorator="['phone', { rules: [{ required: true, message: 'Please input phone!' }] }]" />
        </a-form-item>-->
        <a-tag color="red" class="w-100 p-1" v-if="!empty(error)">{{ error }}</a-tag>
      </a-form>
    </a-modal>
    <a-modal v-model="isVisibleCardAmountModal" title="Update Remaining Cards" on-ok="submitCardAmountChange">
      <template slot="footer">
        <a-button
          key="back"
          @click="
            e => {
              this.userEdit = {};
              this.isVisibleCardAmountModal = false;
            }
          "
        >
          Cancel
        </a-button>
        <a-button key="submit" type="primary" :loading="isLoading" @click="submitCardAmountChange"> Update </a-button>
      </template>
      <div v-if="userEdit.membership" class="d-flex align-items-center">
        <span class="pr-4">Remaining Cards: </span>
        <a-input-number v-model="userEdit.membership.active_cards" :min="0" />
      </div>
    </a-modal>
  </a-card>
</template>
<script>
import { slugData, empty } from '@/utils';
import { includes, get, replace, map, split, cloneDeep, findIndex } from 'lodash';
import AdminService from '@/services/AdminService';
import Constants from '@/constants.js';
export default {
  data() {
    const roleInfo = [
      { text: 'Admin', value: 'admin' },
      { text: 'Care', value: 'care' },
      { text: 'Disciple', value: 'disciple' },
      { text: 'Evangelism', value: 'evangelism' },
      { text: 'Individual', value: 'individual' },
      { text: 'Free', value: 'free_evangelism' },
      { text: 'Moderator', value: 'moderator' },
    ];
    const columns = [
      {
        title: '#ID',
        dataIndex: 'id',
        key: 'id',
        width: 80,
      },
      {
        title: 'First Name',
        dataIndex: 'firstname',
        key: 'firstname',
        width: 150,
      },
      {
        title: 'Last Name',
        dataIndex: 'lastname',
        key: 'lastname',
        width: 150,
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
      },
      {
        title: 'Phone',
        dataIndex: 'cellphone',
        key: 'cellphone',
      },
      {
        title: 'Remaining Cards',
        dataIndex: 'cards',
        key: 'cards',
        scopedSlots: {
          customRender: 'cards',
        },
      },
      {
        title: 'Access',
        dataIndex: 'restricted',
        key: 'restricted',
        scopedSlots: {
          customRender: 'restricted',
        },
        width: 220,
      },
      {
        title: 'Notice',
        dataIndex: 'show_notice',
        key: 'show_notice',
        scopedSlots: {
          customRender: 'show_notice',
        },
        width: 150,
      },
      {
        title: 'Role',
        dataIndex: 'role',
        key: 'role',
        scopedSlots: {
          customRender: 'role',
        },
        filters: roleInfo,
        onFilter: (value, record) => includes(record.role, value),
      },
      {
        title: 'Signature',
        dataIndex: 'signature',
        key: 'signature',
        scopedSlots: {
          customRender: 'signature',
        },
        width: 100,
      },
      {
        title: 'Action',
        key: 'operation',
        fixed: 'right',
        width: 100,
        scopedSlots: {
          customRender: 'action',
        },
      },
    ].map(item => {
      if (!['operation', 'cards', 'restricted', 'role', 'signature', 'show_notice'].includes(item.key)) {
        return {
          ...item,
          scopedSlots: {
            ...item.scopedSlots,
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
          },
          onFilter: (value, record) => record[this.searchedColumn] && includes(slugData(record[this.searchedColumn]), slugData(value)),
          onFilterDropdownVisibleChange: visible => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              }, 0);
            }
          },
        };
      }
      return item;
    });
    return {
      form: this.$form.createForm(this),
      userList: [],
      userListWithoutStory: [],
      userListWithoutOrderCards: [],
      userListWithoutChurchConnection: [],
      searching: '',
      pagination1: [],
      pagination2: [],
      pagination3: [],
      pagination4: [],
      error: '',
      isLoading: true,
      isEdit: false,
      isVisibleModal: false,
      isVisibleCardAmountModal: false,
      confirmDirty: false,
      isChangedPass: false,
      userData: [],
      userEdit: {},
      roleInfo: map(roleInfo, item => ({ label: item.text, value: item.value })),
      columns: columns,
      columns2: columns.filter(c => !['restricted', 'cards', 'operation', 'signature'].includes(c.key)),
      intervalId: null, // <-- add this
      requestIndex: 1, // Start from 1
    };
  },
  watch: {
    userList: {
      async handler(val) {
        this.userData = val;
      },
      immediate: true,
    },
  },
  async created() {
    try {
      this.isLoading = true;
      await this.doInitData();
    } catch (error) {
      console.error({ error });
    } finally {
      this.isLoading = false;
    }
  },
  computed: {
    apiURL() {
      return Constants.API_URL;
    },
  },
  mounted() {
    // Call once immediately
    this.syncDB();

    // Then call every 1 minute (60,000 ms)
    // this.intervalId = setInterval(() => {
    //   this.syncDB();
    // }, 60000);
  },
  beforeDestroy() {
    // Clear the interval to avoid memory leaks
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  methods: {
    empty,
    async onChangeUserRestrict(e, record) {
      const dataSource = cloneDeep(this.userData);
      try {
        const userInfo = await AdminService.user.getUserInfo();
        const indexRecord = findIndex(dataSource, item => item.id === record.id);
        this.isLoading = true;
        this.userData = [];

        const restricted = e.target.value;
        const resp = await AdminService.user.restrict(record.id, userInfo.id);
        console.log({ resp });
        dataSource[indexRecord] = {
          ...record,
          restricted,
          state: restricted ? 'paused' : 'active',
        };
      } catch (error) {
        console.log({ error });
      } finally {
        this.isLoading = false;
        this.userData = dataSource;
      }
    },

    async onChangeUserShowNotice(e, record) {
      const dataSource = cloneDeep(this.userData);
      try {
        const userInfo = await AdminService.user.getUserInfo();
        const indexRecord = findIndex(dataSource, item => item.id === record.id);
        this.isLoading = true;
        this.userData = [];
        var show_notice = e.target.value;
        const resp = await AdminService.user.showNotice(record.id, userInfo.id);
        console.log({ resp });
        dataSource[indexRecord] = {
          ...record,
          show_notice: show_notice,
        };
      } catch (error) {
        console.log({ error });
      } finally {
        this.isLoading = false;
        this.userData = dataSource;
      }
    },

    createUser() {
      this.isVisibleModal = true;
      this.isEdit = false;
    },
    getRoleInfo(text) {
      text = replace(text, '[', '');
      text = replace(text, ']', '');
      return text;
    },
    getRemainingCards(record) {
      const membership = record.membership;
      return membership ? membership.active_cards : 0;
    },
    editRemainingCards(record) {
      const { membership } = record;
      if (!membership) {
        return;
      }

      this.userEdit = cloneDeep(record);
      this.isVisibleCardAmountModal = true;
    },
    async submitCardAmountChange() {
      const record = this.userList.find(u => u.id === this.userEdit.id);

      try {
        await AdminService.user.setCardAmount(this.userEdit.id, this.userEdit.membership.active_cards);
        record.membership = this.userEdit.membership;
      } catch (e) {
        console.log(e);
      } finally {
        this.userEdit = {};
        this.isVisibleCardAmountModal = false;
      }
    },
    async doInitData() {
      await this.fetchUsers();
      await this.fetchUsersWithoutStory();
      await this.fetchUsersWithoutOrderCards();
      await this.fetchUsersWithoutChurchConnection();
    },
    handleCancel() {
      this.userEdit = {};
      this.isVisibleModal = false;
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.error = '';
            this.isLoading = true;
            if (this.isEdit) {
              await AdminService.user.update(this.userEdit.id, {
                ...values,
                role: values.role.toString(),
              });
              this.$notification['success']({
                message: 'Update successful.',
                description: `${values.firstname} ${values.lastname} was updated successfully.`,
              });
            } else {
              this.$notification['success']({
                message: 'Create successful.',
                description: `${values.firstname} ${values.lastname} was created successfully.`,
              });
            }
            await this.doInitData();
            this.isVisibleModal = false;
          } catch (error) {
            console.error({ error });
            this.error = get(error, 'response.data.error', error.message);
          } finally {
            this.isLoading = false;
          }
        }
      });
    },
    handleTable1Change(pagination, filters, sorter) {
      const pager = { ...this.pagination1 };
      pager.current = pagination.current;
      this.pagination1 = pager;
      this.fetchUsers({
        limit: pagination.pageSize,
        page: pagination.current,
        sortField: sorter.field,
        sortOrder: sorter.order,
        ...filters,
      });
    },
    handleTable2Change(pagination, filters, sorter) {
      const pager = { ...this.pagination2 };
      pager.current = pagination.current;
      this.pagination2 = pager;
      this.fetchUsersWithoutStory({
        limit: pagination.pageSize,
        page: pagination.current,
        sortField: sorter.field,
        sortOrder: sorter.order,
        ...filters,
      });
    },
    handleTable3Change(pagination, filters, sorter) {
      const pager = { ...this.pagination3 };
      pager.current = pagination.current;
      this.pagination3 = pager;
      this.fetchUsersWithoutOrderCards({
        limit: pagination.pageSize,
        page: pagination.current,
        sortField: sorter.field,
        sortOrder: sorter.order,
        ...filters,
      });
    },
    handleTable4Change(pagination, filters, sorter) {
      const pager = { ...this.pagination4 };
      pager.current = pagination.current;
      this.pagination4 = pager;
      this.fetchUsersWithoutChurchConnection({
        limit: pagination.pageSize,
        page: pagination.current,
        sortField: sorter.field,
        sortOrder: sorter.order,
        ...filters,
      });
    },

    syncDB() {
      console.log('Sending sync request #' + this.requestIndex);
      // AdminService.user.syncDB(this.requestIndex * 50);
      // if (this.requestIndex >= 50) {
      //   console.log('Reached limit. Stopping repeated calls.');
      //   clearInterval(this.intervalId);
      //   this.intervalId = null;
      //   return;
      // }
      // this.requestIndex++;
    },
    async fetchUsers(params = {}) {
      this.isLoading = true;

      const data = await AdminService.user.getAll({
        limit: 20,
        ...params,
      });

      const pagination = { ...this.pagination1 };
      pagination.total = data.total_count;
      let user_data = [];
      for (let index = 0; index < data.users.length; index++) {
        let element = data.users[index];
        if (element.account && element.account.signature) {
          element['signature'] = element.account.signature;
        } else {
          element['signature'] = '';
        }
        user_data.push(element);
      }
      this.userList = user_data;
      this.pagination1 = pagination;

      this.isLoading = false;
    },
    onDownloadSignature(record) {
      var a = document.createElement('a');
      a.href = record;
      a.download = 'signature.png';
      a.click();
    },
    async fetchUsersWithoutStory(params = {}) {
      this.isLoading = true;

      const data = await AdminService.user.getAllWithoutStory({
        limit: 20,
        ...params,
      });

      const pagination = { ...this.pagination2 };
      pagination.total = data.total_count;
      this.userListWithoutStory = data.users;
      this.pagination2 = pagination;

      this.isLoading = false;
    },
    async fetchUsersWithoutOrderCards(params = {}) {
      this.isLoading = true;

      const data = await AdminService.user.getAllWithoutOrderCards({
        limit: 20,
        ...params,
      });

      const pagination = { ...this.pagination3 };
      pagination.total = data.total_count;
      this.userListWithoutOrderCards = data.users;
      this.pagination3 = pagination;

      this.isLoading = false;
    },
    async fetchUsersWithoutChurchConnection(params = {}) {
      this.isLoading = true;

      const data = await AdminService.user.getAllWithoutChurchConnection({
        limit: 20,
        ...params,
      });

      const pagination = { ...this.pagination4 };
      pagination.total = data.total_count;
      this.userListWithoutChurchConnection = data.users;
      this.pagination4 = pagination;

      this.isLoading = false;
    },
    onEdit(record) {
      this.isEdit = true;
      this.userEdit = record;
      this.isVisibleModal = true;
      let role = this.getRoleInfo(record.role);
      role = split(role, ',').map(item => item.trim());
      this.$nextTick(() => {
        this.form.setFieldsValue({
          firstname: record.firstname,
          lastname: record.lastname,
          email: record.email,
          role,
        });
      });
    },
    async onDelete(record) {
      try {
        this.isLoading = true;
        await AdminService.user.delete(record.id);

        this.$notification['success']({
          message: 'Delete successful.',
          description: `${record.firstname} ${record.lastname} was deleted successfully.`,
        });
        await this.doInitData();
      } catch (error) {
        console.error({ error });
      } finally {
        this.isLoading = false;
      }
    },
    handleSearch(selectedKeys, confirm, key) {
      confirm();
      this.searchedColumn = key;
    },

    handleReset(clearFilters) {
      clearFilters();
    },
    validateToNextPassword(rule, value, callback) {
      const form = this.form;
      if (value && this.confirmDirty) {
        form.validateFields(['confirm'], { force: true });
      }
      callback();
    },
    handleConfirmBlur(e) {
      const value = e.target.value;
      this.confirmDirty = this.confirmDirty || !!value;
    },
    compareToFirstPassword(rule, value, callback) {
      const form = this.form;
      if (value && value !== form.getFieldValue('password')) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('Two passwords that you enter is inconsistent!');
      } else {
        callback();
      }
    },
    isChangedPassword() {
      this.$nextTick(() => {
        this.isChangedPass = !empty(this.form.getFieldValue('password'));
        if (!this.isChangedPass) {
          setTimeout(() => {
            this.form.validateFields(['confirm'], { force: true });
          }, 0);
        }
      });
    },
  },
};
</script>
